import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'contextEditor',
  title: 'igo.contexts',
  icon: 'settings'
})
@Component({
  selector: 'igo-context-editor-tool',
  template: require('./context-editor-tool.component.html'),
  styles: [require('./context-editor-tool.component.styl')]
})
export class ContextEditorToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/context-editor-tool/context-editor-tool.component.ts